import portfolio from '../assets/svg/projects/portfolio.png'
import resume from '../assets/svg/projects/resume.png'
import angularjs from '../assets/svg/projects/angularjs.png'

export const projectsData = [
    {
        id: 1,
        projectName: 'Insurance Modernization',
        projectDesc: 'Modernized insurance systems into scalable microservices on AWS and Azure.',
        tags: ['Java', 'Spring Boot', 'Microservices', 'Azure', 'AWS'],
        code: '',
        demo: '',
        image: portfolio
    },
    {
        id: 2,
        projectName: 'Telecom Portal',
        projectDesc: 'Built a portal with secure APIs, Angular UI, and container workflows.',
        tags: ['Java', 'Spring Boot', 'Angular', 'Docker', 'Kubernetes'],
        code: '',
        demo: '',
        image: angularjs
    },
    {
        id: 3,
        projectName: 'Logistics Web Portal',
        projectDesc: 'Developed web modules with Spring MVC and Oracle integrations.',
        tags: ['Java', 'Spring', 'JSP', 'Oracle', 'HTML/CSS'],
        code: '',
        demo: '',
        image: resume
    }
]
